import usePageWrapper from "PFCore/helpers/use_page_wrapper";
import React from "react";

import { Planner } from "./planner";
import { usePlannerTab } from "./use_planner_tab";

export const PlannerTab = () => {
  const { loaded } = usePlannerTab();
  const WrappedTab = usePageWrapper(Planner);
  return <WrappedTab loading={!loaded} />;
};
